import type { DanceSeoHead } from "../danceSeoTypes.js";

// tr translation of the English source (shared/danceSeoHeads/en.ts); numbers and limits must stay in sync with it.
const head: DanceSeoHead = {
  director: {
    title: "Yapay Zeka Dans Videosu Oluşturucu: Müzikten, Ücretsiz Başla",
    description:
      "Her şarkıyı tam bir yapay zeka dans videosuna dönüştür. Solmi her bölümün koreografisini planlar, dans ve dudak senkronu çekimlerini üretir. Ücretsiz başla.",
    h1: "Yapay Zeka Dans Videosu Oluşturucu – Her Şarkıyı Dans Videosuna Dönüştür",
  },
  photo: {
    title: "Fotoğraf Dans Ettirme: Yapay Zeka ile Fotoğraftan Dans",
    description:
      "Yapay zeka ile fotoğraf dans ettirme: boydan bir fotoğraf yükle, figür seç veya kendi klibini yükle, şarkını ekle. Solmi dansı ritme oturtur. Ücretsiz başla.",
    h1: "Fotoğraf Dans Ettirme – Yapay Zeka ile Fotoğraftan Dans",
  },
  inbound:
    "Sanatçının dans etmesini mi istiyorsun? [Yapay zeka dans videosu oluşturucu](/ai-dance-video-generator), şarkının her bölümü için koreografi planlar ve eksiksiz bir dans videosu render eder.",
};

export default head;
